import * as yup from 'yup';

import {
  validateEmail,
  validateOnlyLettersAndNumber,
  validatePostcode,
} from 'app/utils/validations';

const generalConfigurationFormSchema = yup.object().shape({
  // Company details
  name: yup.string().required('Company name is mandatory'),
  displayName: yup.string(),
  companyNumber: yup
    .string()
    .required('Company number is mandatory')
    .test(
      'Invalid company number',
      'Company number should only contain letters or numbers',
      (value) => !value || validateOnlyLettersAndNumber(value)
    ),
  addressLine1: yup.string().required('Address line 1 is mandatory'),
  addressLine2: yup.string(),
  city: yup
    .string()
    .required('Town/City is mandatory')
    .min(2, 'City should contain at least 2 letters')
    .matches(/^[a-zA-ZÀ-ÿ\s'.-]+$/, "City should only contain letters, spaces, and symbols (.-')"),
  countryCode: yup.string().required('Country is mandatory'),
  postcode: yup
    .string()
    .required('Postcode is mandatory')
    .test('Invalid postcode', 'Enter a valid postcode', (value, context) =>
      validatePostcode(value, context.parent.countryCode)
    ),
  // Billing details
  invoiceRecipientName: yup.string(),
  invoiceEmail: yup
    .string()
    .test('Invalid email', 'Enter a valid email', (value) => !value || validateEmail(value)),
  vatNumber: yup.string(),
});

export default generalConfigurationFormSchema;
